import React from "react";
import {IRecurso} from "@models/recurso/IRecurso.ts";
import {useRecurso} from "@components/recurso/hooks/useRecurso.ts";
import {usePublic} from "@shared/hooks/usePublic.ts";
import {ImportDataComponent, ImportDataComponentProps} from "@components/shared/ImportDataComponent.tsx";
import {ToDateDefault, ToInt, ToMoney} from "@shared/MathHelp.ts";
import {ICreateRecursoDto} from "@components/recurso/models/dto/ICreateRecursoDto.ts";
import dayjs from "dayjs";

interface ImportRecursosComponentProps {
    onCreate?: (v?: IRecurso[]) => void
}

export function ImportRecursoComponent(props: ImportRecursosComponentProps) {
    const {onCreate} = props;
    const {getTemplate} = usePublic()
    const {importRecursos} = useRecurso()

    const importProps: ImportDataComponentProps<ICreateRecursoDto, IRecurso> = {
        onCreate: onCreate,
        filename: "recurso.csv",
        importMethod: importRecursos,
        treatPreviewData: (data) => {
            return ({
                ...data,
                dataInicio: dayjs(data.dataInicio, 'DD/MM/YYYY'),
                dataFim: dayjs(data.dataFim, 'DD/MM/YYYY'),
                baseId: ToInt(data.baseId, {allowUndefined: true}),
            });
        },
        previewGrid: [{field: 'nome', headerName: 'Nome', width: 100},
            {field: 'descricao', headerName: 'Descrição', width: 150},
            {
                field: "valor", headerName: 'Valor', width: 200, renderCell: (params) => {
                    return ToMoney(params.value) ?? ''
                }
            },
            {
                field: "dataInicio", headerName: 'Data Inicio', width: 200, renderCell: (params) => {
                    return ToDateDefault(params.value) ?? ''
                }
            },
            {
                field: "dataFim", headerName: 'Data Fim', width: 200, renderCell: (params) => {
                    return ToDateDefault(params.value) ?? ''
                }
            },
            {field: "baseId", headerName: 'Base Id', width: 200},
        ],
        templateUrl: getTemplate('recurso', 'import-example'),
    }


    return (
        <ImportDataComponent {...importProps}/>
    )

}